export const setCallFlows = (callFlows) => ({
    type: "SET_CALL_FLOWS",
    payload: callFlows,
  });